<template>
  <div id="homepage">
      <img :src="item.pic_front_path" alt="" class="home-feature-image mCS_img_loaded">
  </div>
</template>

<script>
export default {
  props: ["widgets", "item"],
  created(){
    
    
  }
}
</script>
